
import { Component, Prop } from "vue-property-decorator";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import VueTreeselect from "@riophae/vue-treeselect";
import { ALL_WITH_INDETERMINATE, BRANCH_PRIORITY } from "@riophae/vue-treeselect/src/constants";

import { AreaNode } from "@/types/groups/AreaNode";
import AreaTreeBase from "./AreaTreeBase";

/**
 * Area Tree Select component which provides the user with a way to select a group (or device) from a dropdown.
 *
 * @see https://dev.azure.com/sureviewcc/CC/_wiki/wikis/ImmixCC.wiki/918/Area-Tree-Select
 */
@Component({
	components: {
		VuePerfectScrollbar: VuePerfectScrollbar,
		"vue-treeselect": VueTreeselect
	}
})
export default class AreaTreeSelect extends AreaTreeBase {
	@Prop({ default: false }) public appendToBody: boolean;
	@Prop({ default: false }) public fullPathValue: boolean;

	private fullPath = ALL_WITH_INDETERMINATE;
	private groupOnly = BRANCH_PRIORITY;

	protected onInputChanged(node) {
		if (!node) {
			this.$emit("input", null);
			return;
		}

		if(node.length > 0 && this.multiple){
			this.$emit("input", node)
			return 
		}

		if (this.fullPathValue && node.length > 0) {
			let nodesToRemove: number[] = [];
			let selectedNode = node[0];
			let setNodesToRemove = n => {
				if (n.children && n.children.length > 0) {
					n.children.forEach(cn => {
						nodesToRemove.push(cn.id);
						setNodesToRemove(cn);
					});
				}
			};
			setNodesToRemove(selectedNode);
			let result = node.filter(n => !nodesToRemove.includes(n.id)).reverse();
			this.$emit("input", result);

			this.$refs.treeSelect.closeMenu();
			return;
		}
	}

	protected onNodeSelected(node: AreaNode) {
		if (this.fullPathValue === false) {
			this.onNodeSelectedBase(node);
		}
	}

	protected get valueFormat(): string {
		if (this.fullPathValue) {
			return "node";
		}

		if (this.multiple) {
			return "id";
		}
		return typeof this.value === "number" ? "id" : "node";
	}
}
